module.exports = __webpack_public_path__ + "img/logo-light.c90a89a5.svg";